import script from "./MainOnboardFinalStepComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainOnboardFinalStepComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainOnboardFinalStepComponent.vue?vue&type=style&index=0&id=347da61a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347da61a"]])

export default __exports__